<template>
    <select :v-validate="validate" :data-vv-name="name" :name="name">
        <slot></slot>
    </select>
</template>

<script>

import Vue from 'vue'
import Vuex from 'vuex'
import 'select2'
import $ from 'jquery'

export default {
  name: 'Select2',
  props: ['list', 'value', 'name', 'options', 'validate'],
  computed: {
    ...Vuex.mapGetters(['isLoggedIn'])
  },
  data () {
    return {
      defaultSettings: {
        placeholder: 'Select an option',
        allowClear: true
      },
      defaultList: [{
        id: null,
        text: ''
      }]
    }
  },
  beforeMount () {
    let $vm = this
    $.ajaxSetup({
      headers: {
        'Authorization': 'Bearer ' + $vm.$store.getters.isLoggedIn
      },
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + $vm.$store.getters.isLoggedIn)
        console.log(xhr)
      },
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    })
  },
  mounted: function () {
    let settings = Object.assign(this.defaultSettings, this.options || {})
    if (this.list && Array.isArray(this.list)) {
      settings['data'] = this.list
    }
    let vm = this
    $(this.$el)
    // init select2
      .select2(settings)
      .val(this.value)
      .trigger('change')
    // emit event on change.
      .on('change', (e) => {
        vm.$emit('input', $(this.$el).val())
      }).on('clear', () => {
        this.value = ''
      })
  },
  watch: {
    value: function (value) {
      // update value
      $(this.$el)
        .val(value)
        .trigger('change')
    },
    options: function (options) {
      let settings = Object.assign(this.defaultSettings, options || {})
      if (this.list && Array.isArray(this.list)) {
        settings['data'] = this.list
      }
      // update options
      $(this.$el).empty().select2(settings)
    },
    list: function (list) {
      let settings = Object.assign(this.defaultSettings, this.options || {})
      if (this.list && Array.isArray(list)) {
        settings['data'] = list
      }
      // update options
      $(this.$el).empty().select2(settings)
    }
  },
  destroyed: function () {
    $(this.$el).off().select2('destroy')
  }
}
</script>

<style scoped>

</style>
